import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { APIEndPoints } from 'src/app/configs/api-endpoints';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HabitDrillsService {
  url = environment.apiBaseUrl;
  
  
  constructor(private http: HttpClient) { }

  self() {
    return this.http.get<{ data: any, result: number, msg: string }>(`${this.url}users/self`).pipe(map((res) => {
       return res.data;
   }));
 }

 gethabitdrills(programActivationId:string) {
  return this.http.get(`${this.url}${APIEndPoints.HabitDrills.GET_habit}?programActivationId=${programActivationId}`);
}

getHabitDrillInfo(programActivationId:string,courseId:string,habitDrillUuid:string){
  return this.http.get(`${this.url}${APIEndPoints.HabitDrills.GET_HABIT_DRILL_INFO}${habitDrillUuid}?programActivationId=${programActivationId}&courseId=${courseId}`);
}

postSubmissionData(data:any,habitDrillUuid:string){
  return this.http.post(`${this.url}${APIEndPoints.HabitDrills.POST_HABIT_DRILL_INFO}${habitDrillUuid}`,data);
}
}
